export const KAKAO_APP_KEY = '62f206154fa27a91c152c4d660d47813';

export const loadKakaoSdk = () => {
    return new Promise((resolve, reject) => {
        if (window.Kakao && window.Kakao.isInitialized()) {
            return resolve(window.Kakao);
        }
        
        if (document.getElementById('kakao-sdk')) {
            // Already loading, just wait a bit (basic polling for simplicity)
            const checkInt = setInterval(() => {
                if (window.Kakao && window.Kakao.isInitialized()) {
                    clearInterval(checkInt);
                    resolve(window.Kakao);
                }
            }, 100);
            return;
        }

        const script = document.createElement('script');
        script.id = 'kakao-sdk';
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js';
        script.onload = () => {
            if (window.Kakao && !window.Kakao.isInitialized()) {
                window.Kakao.init(KAKAO_APP_KEY);
            }
            resolve(window.Kakao);
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
};

export const executeKakaoShare = async ({ url, title, description, imageUrl }) => {
    try {
        const kakao = await loadKakaoSdk();
        const shareUrl = url || window.location.href;
        
        kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
                title: title || '가까운솔루션',
                description: description || '현장에 최적화된 프라이빗 IT 솔루션을 만나보세요.',
                imageUrl: imageUrl || 'https://www.ggusol.com/og-default.png?v=20261022',
                link: {
                    mobileWebUrl: shareUrl,
                    webUrl: shareUrl,
                },
            },
            buttons: [
                {
                    title: '자세히 보기',
                    link: {
                        mobileWebUrl: shareUrl,
                        webUrl: shareUrl,
                    },
                },
            ],
        });
    } catch (err) {
        console.error('Failed to load or execute Kakao Share:', err);
        alert('카카오톡 SDK 로딩 중 문제가 발생했습니다.');
    }
};
